<template>
  <div class="app">
    <AppNav/>
      <keep-alive>
       <router-view></router-view>
      </keep-alive>
    <AppFooter/>
  </div>
</template>
<script>
import { addBackToTop } from 'vanilla-back-to-top'
import AppNav from './AppNav.vue'
import AppFooter from './AppFooter.vue'
export default {
  name: 'App',
  components: {
    AppNav,
    AppFooter
  },
  mounted () {
    addBackToTop()
  }
}
</script>
<style >
body{
  margin: 0;
  font-size: 14px;
  font-family: Helvetica Neue,Helvetica,Arial,sans-serif;
}

div.app{
  border-left: 2px solid #D53A35;
  border-right: 2px solid #D53A35;
}
div.vue-back-to-top{
  background-color: #3e392c;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
div.vue-back-to-top:hover{
  background-color: #3e392c
}

.b2t .el-icon-caret-top::before {
    position: relative;
    content: "\e78f" !important;
    left: 13px;
    top: 11px;
    display: block;
    transform:scale(2,2);
    -ms-transform:scale(2,2); /* IE 9 */
    -moz-transform:scale(2,2); /* Firefox */
    -webkit-transform:scale(2,2); /* Safari 和 Chrome */
    -o-transform:scale(2,2); /* Opera */
}

@media(max-width: 500px){
  .el-pagination__sizes {
      margin: 0 !important;
  }

  .el-pager li {
      min-width: 15.5px !important;
  }
}
</style>
